import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['current']

  connect () {
    if (this.hasCurrentTarget) {
      this.currentTarget.scrollIntoView({ inline: 'center', block: 'nearest' })
    }
  }
}
